module.exports = __webpack_public_path__ + "assets/7cb2d91be40a0579f66763560fa6f8ee.mp3";